import { logic } from '../../../logic';
import { errorAlert } from '../../../utils/Utils';
import { ConnectedWallet } from './kit.type';
import toast from 'react-hot-toast';

const ISSUE_FUNCTION_METHODS = [
  {
    // mint
    method_id: 101,
    inputs: [{ name: 'to', placeholder: 'Address to mint' }],
    onClick: async (
      inputValue: {
        to: string;
        token_uri: string;
        // amount: number;
      }[],
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.microChainId || !option.contractAddress || !option.kitId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const parseInputValue = inputValue.map((item) => {
          return {
            to: item.to,
            tokenUri: item.token_uri,
          };
        });
        const { result, error } = await logic.nftKit.nftKitIssuancesWithMetamask(parseInputValue, option.microChainId, option.contractAddress);
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const parseInputValue = inputValue.map((item) => {
          return {
            option: {
              recipientAddress: item.to,
              tokenUri: item.token_uri,
            },
          };
        });
        const { result, error } = await logic.nftKit.nftKitIssuancesWithServer(option.kitId, option.password, parseInputValue, {
          webhookUrl: option.webhookUrl,
          useWebhook: option.useWebhook,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
  {
    // balanceOf
    method_id: 102,
    inputs: [{ name: 'account', placeholder: 'Account address to verify balance' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.account) {
        return;
      }
      const { result, error } = await logic.nftKit.getAllTokenBalance(option.kitId, [inputValue.account]);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // setMetadata
    method_id: 103,
    inputs: [
      { name: 'tokenId', placeholder: 'Token ID to set metadata' },
      { name: 'tokenUri', placeholder: 'Token URI' },
    ],
    onClick: async (
      inputValue: {
        tokenId: string;
        tokenUri: string;
      },
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.kitId || !option.contractAddress || !option.microChainId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.nftKitSetMetadataUriWithMetamask(
          option.microChainId,
          option.contractAddress,
          inputValue.tokenId,
          inputValue.tokenUri
        );
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result, error } = await logic.nftKit.nftKitSetMetadataWithServer(option.kitId, option.password, inputValue.tokenId, inputValue.tokenUri, {
          webhookUrl: option.webhookUrl,
          useWebhook: option.useWebhook,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        return result;
      }
    },
  },
  {
    // viewNFTDetails
    method_id: 104,
    inputs: [{ name: 'tokenId', placeholder: 'Token ID to view details' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.tokenId) {
        return;
      }
      const { result, error } = await logic.nftKit.nftKitGetMetadata(option.kitId, inputValue.tokenId);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // getStatistics
    method_id: 1050,
    inputs: [
      { name: 'address', placeholder: 'Address to get member statistics' },
      { name: 'tokenId', placeholder: 'Token ID to get member statistics' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.address || !inputValue.tokenId) {
        return;
      }
      const { result, error } = await logic.nftKit.getHolderList(option.kitId, {
        addresses: [inputValue.address],
        tokenIds: [inputValue.tokenId],
      });
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result?.rows || [];
    },
  },
  {
    // burn
    method_id: 106,
    inputs: [
      { name: 'account', placeholder: 'Address to burn' },
      { name: 'id', placeholder: 'NFT ID to burn' },
      // { name: 'amount', placeholder: 'Amount to burn' },
    ],
    onClick: async (
      inputValue: {
        account: string;
        id: string;
        // amount: number;
      },
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.microChainId || !option.contractAddress || !option.kitId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.nftKitBurnIntegrationWithMetamask(inputValue.id, option.microChainId, option.contractAddress, {
          redeemingAddress: inputValue.account,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result, error } = await logic.nftKit.nftKitRedeemWithServer(option.kitId, option.password, Boolean(option.useWebhook), inputValue.id, {
          redeemingAddress: inputValue.account,
          webhookUrl: option.webhookUrl,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
];

const TRANSFER_FUNCTION_METHODS = [
  {
    // transfer
    method_id: 201,
    inputs: [
      { name: 'to', placeholder: 'Address to transfer' },
      { name: 'id', placeholder: 'NFT ID to transfer' },
      { name: 'from', placeholder: 'Address to transfer from' },
    ],
    onClick: async (
      inputValue: {
        to: string;
        id: string;
        from?: string;
      }[],
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.microChainId || !option.contractAddress || !option.kitId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const parseInputValue = inputValue.map((item) => {
          return {
            toAddress: item.to,
            tokenId: item.id,
            fromAddress: item.from || '',
          };
        });
        const { result, error } = await logic.nftKit.nftKitTransferIntegrationWithMetamask(parseInputValue, option.microChainId, option.contractAddress);
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const parseInputValue = inputValue.map((item) => {
          return {
            recipientAddress: item.to,
            tokenId: item.id,
            option: {
              senderAddress: item.from,
            },
          };
        });
        const { result, error } = await logic.nftKit.nftKitTransferWithServer(option.kitId, option.password, Boolean(option.useWebhook), parseInputValue, {
          webhookUrl: option.webhookUrl,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
  {
    // balanceOf
    method_id: 202,
    inputs: [{ name: 'account', placeholder: 'Account address to verify balance' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
      }
    ) => {
      if (!option.kitId || !inputValue.account) {
        return;
      }
      const { result, error } = await logic.nftKit.getAllTokenBalance(option.kitId, [inputValue.account]);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // transfer-history
    method_id: 2030,
    inputs: [
      { name: 'address', placeholder: 'Address to view transfer history' },
      {
        name: 'tokenId',
        placeholder: 'Token ID to view transfer history',
      },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
      }
    ) => {
      if (!option.kitId || !inputValue.address) {
        return;
      }
      const { result, error } = await logic.nftKit.getNFTTransferHistory(option.kitId, inputValue.address, { tokenId: inputValue.tokenId });
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
];

const APPROVAL_FUNCTION_METHODS = [
  {
    // approve
    method_id: 301,
    inputs: [
      { name: 'operator', placeholder: 'Address to approve' },
      { name: 'isApproved', placeholder: 'Approval status. Please enter true or false' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.microChainId || !option.contractAddress || !option.kitId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.nftKitApproveTransactionWithMetamask(option.microChainId, option.contractAddress, inputValue.operator);
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const approval = inputValue.isApproved === 'true' ? true : false;
        const { result, error } = await logic.nftKit.nftKitApproveWithServer(
          option.kitId,
          option.password,
          inputValue.operator,
          Boolean(option.useWebhook),
          approval,
          {
            webhookUrl: option.webhookUrl,
          }
        );
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
  {
    // allowance
    method_id: 302,
    inputs: [
      { name: 'owner', placeholder: 'Owner address' },
      { name: 'spender', placeholder: 'Spender address' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.owner || !inputValue.spender) {
        return;
      }
      const { result, error } = await logic.nftKit.getNFTAllowanceHistory(option.kitId, inputValue.owner, inputValue.spender);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // approval-history
    method_id: 4030,
    inputs: [{ name: 'address', placeholder: 'Address to view approval history' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.address) {
        return;
      }
      const { result, error } = await logic.nftKit.getNFTApprovalsHistory(option.kitId, inputValue.address, {});
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // get role list
    method_id: 3040,
    inputs: [],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId) {
        return;
      }
      const { result, error } = await logic.nftKit.getRoleList(option.kitId);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      const { rows } = result || {};
      return rows;
    },
  },
  {
    // set role
    method_id: 305,
    inputs: [
      { name: 'address', placeholder: 'Address to add role' },
      { name: 'hasRole', placeholder: 'Has Role' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.microChainId || !option.contractAddress || !option.kitId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.addRoleWithMetamask(option.microChainId, option.contractAddress, 'MANAGER_ROLE', {
          hasRole: inputValue.hasRole !== 'false',
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result, error } = await logic.nftKit.addRole(option.kitId, option.password, inputValue.address, 'MANAGER_ROLE', inputValue.hasRole !== 'false');
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result.transaction_hash;
      }
    },
  },
];

const ENTRANCE_FUNCTION_METHODS = [
  {
    // createEntrance
    method_id: 40100,
    inputs: [
      { name: 'entranceName', placeholder: 'Entrance Name' },
      {
        name: 'location',
        placeholder: 'Entrance Location',
      },
      {
        name: 'expirationTime',
        placeholder: 'Expiration Time',
      },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.contractAddress || !option.kitId || !option.connectedWallet) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.createEntranceWithMetamask(option.contractAddress, inputValue.entranceName);
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result, error } = await logic.nftKit.createEntrance(option.kitId, inputValue.entranceName, option.password, {
          location: inputValue.location,
          expirationTime: inputValue.expirationTime,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
  {
    // update entrance
    method_id: 402,
    inputs: [
      {
        name: 'entranceId',
        placeholder: 'Entrance ID',
      },
      { name: 'entranceName', placeholder: 'Entrance Name' },
      { name: 'location', placeholder: 'Entrance Location' },
      { name: 'expirationTime', placeholder: 'Expiration Time' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId) {
        return;
      }
      const { result, error } = await logic.nftKit.updateEntrance(option.kitId, inputValue.entranceId, {
        entranceName: inputValue.entranceName,
        location: inputValue.location,
        expirationTime: inputValue.expiration,
      });
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later ');
        return;
      }
      return result;
    },
  },
  {
    // get entrance list
    method_id: 40300,
    inputs: [],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.kitId) {
        return;
      }
      const { result, error } = await logic.nftKit.getEntranceList(option.kitId);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later ');
        return;
      }
      return result?.rows || [];
    },
  },
  {
    // viewNFTDetails
    method_id: 404,
    inputs: [{ name: 'tokenId', placeholder: 'Token ID to view details' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.tokenId) {
        return;
      }
      const { result, error } = await logic.nftKit.nftKitGetMetadata(option.kitId, inputValue.tokenId);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // balanceOf
    method_id: 405,
    inputs: [{ name: 'account', placeholder: 'Account address to verify balance' }],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.account) {
        return;
      }
      const { result, error } = await logic.nftKit.getAllTokenBalance(option.kitId, [inputValue.account]);
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      return result;
    },
  },
  {
    // create entrance code
    method_id: 406,
    inputs: [
      { name: 'entranceId', placeholder: 'Entrance ID' },
      { name: 'tokenId', placeholder: 'Token ID' },
      { name: 'endTime', placeholder: 'End Time' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
      }
    ) => {
      if (!option.kitId || !inputValue?.entranceId || !inputValue?.tokenId || !option.contractAddress || !option.connectedWallet || !option.microChainId) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result: holderSignatureResult, error: makeHolderSignatureError } = await logic.nftKit.createSignatureWithMetamask(
          option.microChainId,
          option.contractAddress,
          inputValue.tokenId,
          inputValue.entranceId,
          option.kitId
        );
        if (makeHolderSignatureError) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        const { signature: holderSignature } = holderSignatureResult || {};
        const { result, error } = await logic.nftKit.createEntranceCode(option.kitId, inputValue.entranceId, inputValue.tokenId, holderSignature, {
          endTime: inputValue.endTime,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result: holderSignatureResult, error: makeHolderSignitureError } = await logic.nftKit.createSignature(
          option.kitId,
          inputValue.entranceId,
          option.password,
          inputValue.tokenId
        );
        if (makeHolderSignitureError) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        const { signature: holderSignature } = holderSignatureResult || {};
        const { result, error } = await logic.nftKit.createEntranceCode(option.kitId, inputValue.entranceId, inputValue.tokenId, holderSignature, {
          endTime: inputValue.endTime,
        });
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later');
          return;
        }
        return result;
      }
    },
  },
  {
    // verify entrance code
    method_id: 407,
    inputs: [
      { name: 'entranceId', placeholder: 'Entrance ID' },
      { name: 'tokenId', placeholder: 'Token ID' },
      { name: 'code', placeholder: 'Code' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
        microChainId?: number;
        contractAddress?: string;
        connectedWallet?: ConnectedWallet;
        password?: string;
        useWebhook?: boolean;
        webhookUrl?: string;
      }
    ) => {
      if (!option.kitId || !option.microChainId || !option.contractAddress || !option.connectedWallet) {
        return;
      }
      const { connectedWallet } = option;
      const { connectWalletType: walletType } = connectedWallet || {};
      if (walletType === 'metamask') {
        const { result, error } = await logic.nftKit.verifyEntranceCodeWithMetamask(
          option.microChainId,
          option.contractAddress,
          inputValue.tokenId,
          inputValue.code,
          inputValue.entranceId,
          option.kitId
        );
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
      if (walletType === 'accountManager') {
        if (!option.password || option.password.length > 6) {
          return;
        }
        const { result: getHolderResult, error: getHolderError } = await logic.nftKit.getHolderList(option.kitId, { tokenIds: [inputValue.tokenId] });
        if (getHolderError) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        const { rows } = getHolderResult;
        const holder = rows.find((holder) => holder.balance);

        const { result, error } = await logic.nftKit.verifyEntranceCode(
          option.kitId,
          inputValue.entranceId,
          option.password,
          inputValue.tokenId,
          holder?.address as string,
          inputValue.code,
          { useWebhook: option.useWebhook, webhookUrl: option.webhookUrl }
        );
        if (error) {
          errorAlert('Failed to execute function. Check your parameter or try later ');
          return;
        }
        return result;
      }
    },
  },
  {
    // get entrance history
    method_id: 4080,
    inputs: [
      { name: 'entranceId', placeholder: 'Entrance ID to view entrance history' },
      { name: 'holderAddress', placeholder: 'Address to view entrance history' },
      { name: 'tokenId', placeholder: 'Token ID to view entrance history' },
      { name: 'authorizerAddress', placeholder: 'Address to authorize entrance' },
      { name: 'transactionHash', placeholder: 'Transaction hash to verify entrance' },
    ],
    onClick: async (
      inputValue: any,
      option: {
        kitId?: number;
      }
    ) => {
      if (!option.kitId || !inputValue.entranceId) {
        return;
      }
      const { result, error } = await logic.nftKit.getEntranceHistory(option.kitId, inputValue.entranceId, {
        holderAddress: inputValue.holderAddress,
        tokenId: inputValue.tokenId,
        authorizerAddress: inputValue.authorizerAddress,
        transactionHash: inputValue.transactionHash,
      });
      if (error) {
        errorAlert('Failed to execute function. Check your parameter or try later');
        return;
      }
      const { rows } = result || {};
      return rows;
    },
  },
];

export const NFT_KIT_FUNCTION_METHODS = {
  1: ISSUE_FUNCTION_METHODS,
  2: TRANSFER_FUNCTION_METHODS,
  3: APPROVAL_FUNCTION_METHODS,
  4: ENTRANCE_FUNCTION_METHODS,
};
